<div class="container-fluid workload">
  <form [formGroup]="clientForm">
    <h2 class="step-title">Asignar cliente a trabajo</h2>
    <hr class="solid" />
    <div>
      <h2 class="section-title">Datos personales</h2>
      <div class="row">
        <div class="col-12 col-lg-6 pe-lg-0">
          <div class="row m-0 p-0">
            <div class="col-2 p-0 tp-doc-type">
              <mat-form-field floatLabel="always" class="w-100" appearance="outline">
                <mat-label>Tipo</mat-label>
                <mat-select
                  #matSelect
                  required
                  [(value)]="selectedType"
                  formControlName="identificationTypeId"
                  (selectionChange)="changeSelectedType(selectedType)"
                  >
                  @for (type of identificationTypeList; track type) {
                    <mat-option
                      [value]="type.id"
                      >
                      {{ type.name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-10">
              @if (checkSelectedType('DNI')) {
                <mat-form-field floatLabel="always"
                  class="w-100"
                  appearance="outline"
                  >
                  <mat-label>DNI</mat-label>
                  <input
                    matInput
                    placeholder="DNI"
                    name="identificationNumber"
                    formControlName="identificationNumber"
                    required
                    type="number"
                    onKeyPress="if(this.value.length==8) return false;"
                    (keyup.enter)="getClient()"
                    (blur)="getClient()"
                    (keydown)="validateOnlyNumbers($event)"
                    [maxlength]="10"
                    />
                    <button class="btnSearch" (click)="getClient()" aria-label="Buscar cliente" title="Buscar cliente">
                      <mat-icon>search</mat-icon>
                    </button>
                    @if (
                      clientForm.get('identificationNumber')?.hasError('pattern')
                      ) {
                      <mat-error
                        >
                        El DNI no puede contener menos de 7 dígitos.
                      </mat-error>
                    }
                  </mat-form-field>
                }
                @if (checkSelectedType('CUIT')) {
                  <mat-form-field floatLabel="always"
                    class="w-100"
                    appearance="outline"
                    >
                    <mat-label>CUIT</mat-label>
                    <input
                      matInput
                      min="0"
                      max="99999999999"
                      placeholder="CUIT"
                      name="identificationNumber"
                      formControlName="identificationNumber"
                      required
                      type="number"
                      onKeyPress="if(this.value.length==11) return false;"
                      (keyup.enter)="getClient()"
                    (blur)="getClient()"
                      (keydown)="validateOnlyNumbers($event)"
                      />
                      <button class="btnSearch" (click)="getClient()" aria-label="Buscar cliente" title="Buscar cliente">
                        <mat-icon>search</mat-icon>
                      </button>
                      @if (
                        clientForm.get('identificationNumber')?.hasError('pattern')
                        ) {
                        <mat-error
                          >
                          El CUIT no puede contener menos de 11 dígitos.
                        </mat-error>
                      }
                    </mat-form-field>
                  }
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <mat-form-field floatLabel="always" class="w-100" appearance="outline">
                <mat-label>Nombre completo</mat-label>
                <input
                  matInput
                  placeholder="Nombre completo"
                  name="name"
                  formControlName="name"
                  required
                  maxlength="170"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-6">
                <div class="form-group" formGroupName="phone">
                  <div class="row m-0 p-0">
                    <div class="col-2 p-0 phoneCode">
                      <mat-form-field floatLabel="always" class="w-100" appearance="outline">
                        <mat-label>País</mat-label>
                        <mat-select
                          #matSelect
                          required
                          [(value)]="selectedCode"
                          formControlName="countryCode"
                          (selectionChange)="changeSelection(selectedCode)"
                          >
                          <mat-select-trigger>
                            <img with="10px" height="10px" src="{{ selectedflag }}" alt=""/>
                          </mat-select-trigger>
                          @for (code of countryCodesList; track code) {
                            <mat-option
                              [value]="code.countryCode"
                              >
                              <img with="10px" height="10px" src="{{ code.src }}" alt=""/>
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="col-10 p-0" style="padding-left: 10px !important">
                      <mat-form-field floatLabel="always" class="w-100" appearance="outline">
                        <mat-label>Número</mat-label>
                        <input
                          matInput
                          type="text"
                          inputmode="numeric"
                          autocomplete="tel-national"
                          placeholder="10 dígitos"
                          name="number"
                          formControlName="number"
                          id="number"
                          (input)="keepPhoneDigits($event, clientForm.get('phone')?.get('number') ?? null)"
                          />
                          @if (
                            clientForm
                            .get('phone')
                            ?.get('number')
                            ?.hasError('pattern')
                            ) {
                            <mat-error
                              >
                              El teléfono no puede contener menos de 10 dígitos.
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="row">
                    <mat-form-field floatLabel="always" [class.col-9]="showCheckboxNoMail" appearance="outline">
                      <mat-label>Email</mat-label>
                      <input
                        matInput
                        placeholder="correo@email.com"
                        name="email"
                        type="email"
                        formControlName="email"
                        required
                        maxlength="100"
                        />
                        @if (clientForm.get('email')?.hasError('email')) {
                          <mat-error>
                            El formato del correo es inválido.
                          </mat-error>
                        }
                      </mat-form-field>
                      @if (showCheckboxNoMail) {
                        <div class="col-3 m-auto pb-3 tp-no-mail">
                          <mat-checkbox
                            formControlName="allowEmptyEmail"
                            (change)="noMailClient()"
                            >Sin email</mat-checkbox
                            >
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
